@if (productViewLayout.content?.deliveryNote) {
  <label-pane
    [transparent]="client.isS||client.isM">
    <i class="icon-delivery inline-flex p-r-2"
    [style.font-size.em]="1.4"></i>
    <p *iCms="'deliveryNote' of productViewLayout.content; content: 'html'"
    [style.line-height.em]="1"></p>
  </label-pane>
}